<ng-container *transloco="let t">
  @if (showHeader && !bareRoute) {
    <app-header
      class="mat-elevation-z6"
      [navbarOpen]="showDrawer && (sideNav?.opened ?? true)"
      [isMobile]="isMobileView"
      (navbarToggled)="navBarToggle()"
    />
    <br />
  }
  <!-- Creates a layout with a left-positioned sidenav and explicit content. -->
  <mat-sidenav-container class="main-container" [class.content-page]="showDrawer && !bareRoute" [class.bare-route]="bareRoute" autosize>
    @if (showDrawer && isLoggedIn && !bareRoute) {
      <mat-sidenav
        [mode]="isMobileView ? 'over' : 'side'"
        [opened]="isOpened"
        (opened)="isOpened = true"
        (closed)="isOpened = false"
        #sideNav
      >
        <app-navigation [staticPageMenu]="staticPageMenu" (itemSelected)="onMenuItemSelected()" />
      </mat-sidenav>
    }
    <mat-sidenav-content>
      @if (navigating) {
        <mat-progress-bar mode="indeterminate" style="position: absolute; top: 40%; left: 0" />
      }
      @if (!awaitingLogin) {
        <div [class.navigating]="navigating" [class.full-width]="isMobileView" class="main-layout" [ngClass]="mainLayoutClass">
          <router-outlet />
        </div>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>

  @if (showReload) {
    <div class="floating-btn">
      <a mat-raised-button color="accent" tabindex="0" (click)="reload()" (keydown.enter)="reload()">
        Update! (Auto update in {{ reloadTime }}s)
        <mat-icon>refresh</mat-icon>
      </a>
    </div>
  }

  @if (serverUnreachable$ | async) {
    <app-server-unreachable-overlay />
  }
</ng-container>
